import omit from 'lodash.omit';
import isEmpty from '~/utilities/isEmpty';
import { AppliedFilters } from '~/validations/AppliedFilters';

export default function useIsSavableSearch(appliedFilters: AppliedFilters) {
  return !isEmpty(omit(appliedFilters, ['isFreeDelivery', 'vehicleIds']));
}
